export default __webpack_public_path__ + "static/accroche-video-bg-b9dae1430ff7c6f0bfb5eddf7107edba.webm";